import { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { Actions as ADMIN_ACTIONS } from "../store/actions/adminActions";
import { Actions as ADVISOR_ACTIONS } from "../store/actions/advisorActions";
import { Actions as COMPANY_ACTIONS } from "../store/actions/companyActions";
import AdminCompanyList from "../components/admin/AdminCompanyList";
import AdvisorList from "../components/admin/AdvisorList";
import PaymentAndBilling from "../components/admin/PaymentAndBilling";
import CertificateModal from "../components/admin/modals/CertificateModal";
import UserInfoModal from "../components/admin/modals/UserInfoModal";
import NewAdvisorModal from "@/components/admin/modals/NewAdvisorModal";
import GlobalUserNotification from "@/components/admin/GlobalUserNotification";

const Admin = ({ getAdvisorList, getAdminOrganisations }) => {
	useEffect(() => {
		getAdminOrganisations();
		getAdvisorList();
	}, []);

	return (
		<>
			<NewAdvisorModal />
			<UserInfoModal />
			<CertificateModal />
			<Routes>
				<Route
					path="organisations"
					element={<AdminCompanyList />}
				/>
				<Route
					path="advisors"
					element={<AdvisorList />}
				/>
				<Route
					path="payment-and-billing/*"
					element={<PaymentAndBilling />}
				/>
				<Route
					path="notifications"
					element={<GlobalUserNotification />}
				/>
			</Routes>
		</>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	getAdminOrganisations: () => dispatch(COMPANY_ACTIONS.getAdminOrganisations()),
	openUserModal: () => dispatch(ADMIN_ACTIONS.getUserModal(true)),
	openCertificateModal: () => dispatch(ADMIN_ACTIONS.getCertificateModal(true)),
	getAdvisorList: () => dispatch(ADVISOR_ACTIONS.getAdvisorList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
